/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AssistantButton = function () {
  function AssistantButton() {
    _classCallCheck(this, AssistantButton);
    this.assistantButtons = Array.from(document.querySelectorAll('.assistant-button'));
    this.isOpen = false;
  }
  return _createClass(AssistantButton, [{
    key: "setListeners",
    value: function setListeners() {
      var _this = this;
      if (this.assistantButtons.length > 0) {
        this.assistantButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            if (!_this.isOpen) {
              window.GuideSDK.bot.openWindow();
              _this.isOpen = true;
            } else {
              window.GuideSDK.bot.closeWindow();
              _this.isOpen = false;
            }
          });
        });
      }
    }
  }], [{
    key: "hideLauncher",
    value: function hideLauncher() {
      var interval = setInterval(function () {
        if (window.GuideSDK) {
          clearInterval(interval);
          window.GuideSDK.bot.style.add("\n          div[class*=\"LauncherPortal\"] {\n            display: none;\n          }\n        ");
        }
      }, 200);
      setTimeout(function () {
        return clearInterval(interval);
      }, 3000);
    }
  }]);
}();
export { AssistantButton as default };
(function () {
  var assistantButton = new AssistantButton();
  assistantButton.setListeners();
})(Drupal);